import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-c-chica-rendicion-gasto',
  templateUrl: './c-chica-rendicion-gasto.component.html',
  styleUrls: ['./c-chica-rendicion-gasto.component.scss']
})
export class CChicaRendicionGastoComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
